import { GET_SERVICOS } from 'volto-ministerio-publico-federal/constants';

export function getServicos(pastaPath: string) {
  return {
    type: GET_SERVICOS,
    pastaPath,
    request: {
      op: 'get',
      path: `${pastaPath}/@servicos`,
    },
  };
}
